import { useCallback } from 'react'
import { CurrencyOptionProps } from './CurrencyOption.types'

/** Binds the tile to its own currency code. */
export function useCurrencyOptionController({ option, onSelect }: CurrencyOptionProps) {
  const onSelectClick = useCallback(() => onSelect(option.code), [option.code, onSelect])

  return { onSelectClick }
}
